import { render, staticRenderFns } from "./set-dimension.vue?vue&type=template&id=37e4c13e&scoped=true"
import script from "./set-dimension.vue?vue&type=script&lang=ts"
export * from "./set-dimension.vue?vue&type=script&lang=ts"
import style0 from "./set-dimension.vue?vue&type=style&index=0&id=37e4c13e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e4c13e",
  null
  
)

export default component.exports